import { share, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { LocalEntityModel } from '../models/index';

import * as _ from 'lodash';
import { ApiService } from './api.service';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from './offlineApi.service';
import { AppConstants } from '../../utils/appConstants.class';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class LocalEntityService {
  private localEntities: any = [];
  private localEntitiesLoader: Observable<any>;

  constructor(protected apiService: ApiService, private offlineApi: OfflineApiService, private logService: LogService) {
    this.loadLocalEntitiesData();
  }

  public loadLocalEntitiesData() {
    const self = this;
    this.localEntitiesLoader = this.loadLocalEntities().pipe(
      map((res: any) => {
        this.localEntitiesLoader = null;
        const localEntities = res.LocalEntities ? res.LocalEntities : res;

        _.map(localEntities, (el) => {
          self.localEntities.push(new LocalEntityModel(el.Label, el.Value, el.Countries));
        });

        return this.localEntities;
      }),
      share()
    );
    this.localEntitiesLoader.subscribe(
      (data: any) => {},
      (err: any) => this.logService.logError('Local Entities loading error')
    );
  }

  private loadLocalEntities() {
    const url = '/localentities';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.localEntities);
  }

  getValue(value: any, array: any): string {
    const obj = _.find(array, ['value', value]);
    return obj ? obj.label : '';
  }

  public getLocalEntities(): Observable<any> {
    if (this.localEntitiesLoader) {
      return this.localEntitiesLoader;
    }
    return new BehaviorSubject(this.localEntities).asObservable();
  }
}
